/* eslint-disable react/no-danger */
import React from "react";
import { createRoot } from "react-dom/client";

// import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
// import RefreshIndicator from 'material-ui/RefreshIndicator';

import Button from "@mui/material/Button";
import Icon from "@mui/material/Icon";
import Input from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import LinearProgress from "@mui/material/LinearProgress";
import CircularProgress from "@mui/material/CircularProgress";

import roles from "./models/roles.js";
import { getLandingPage } from "./models/roleLanding.js";

import "./style/login.scss";

import { I18nextProvider, translate } from "react-i18next";
import i18next, { getDetectedCounty } from "./i18n.js";
import { ThemeProvider } from "@mui/material/styles";
import muiTheme from "./muiTheme.js";

import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";

class LoginFormEn extends React.Component {
  formRef = React.createRef();
  tokenRef = React.createRef();
  gdprContentRef = React.createRef();
  state = {
    name: "",
    password: "",
    logging: false,
    errname: "",
    errpassword: "",
    loginError: "",
    gdpr: false,
    gdprDialog: false,
    gdprAccepting: false,
  };
  errors = {
    name: "no username",
    password: "no password",
  };

  constructor() {
    super();
  }

  handleChange = (name, value) => {
    this.setState({ ...this.state, [name]: value });
  };

  componentDidMount() {
    this.tokenRef.current.value = localStorage.getItem("token");

    let brandobj = localStorage.getItem("brandObj");
    if (brandobj) {
      brandobj = JSON.parse(brandobj);
      // console.log("BRANDO OJB", brandobj);

      this.setState({
        ...brandobj,
      });
    }
    // setTimeout(() => {
    //     console.log("change lanugage");
    //     i18next.changeLanguage("de");

    //   }, 3000)
  }

  login(e) {
    const that = this;
    // console.log("c")
    e.preventDefault();

    that.tokenRef.current.value = "";
    let user = true;
    let pass = true;

    this.setState({
      loginError: "",
    });

    if (this.state.name === "") {
      this.setState({
        errname: this.errors["name"],
      });

      user = false;
    }

    if (this.state.password === "") {
      this.setState({
        errpassword: this.errors["password"],
      });

      pass = false;
    }

    if (user === false || pass === false) return;

    this.setState({
      logging: true,
    });

    fetch("/login", {
      method: "POST",
      redirect: "follow",
      headers: new Headers({
        "Content-Type": "application/json",
      }),
      body: JSON.stringify({
        user: this.state.name,
        pass: this.state.password,
        webLogin: true,
      }),
    })
      .then(function (data) {
        // console.log("response");

        that.setState({
          logging: false,
        });

        if (data.status === 200) {
          return data.json();
        }
      })
      .then(function (resp) {
        //console.log(resp);
        that.tmpToken = null;

        if (!resp || resp.success !== true) {
          that.setState({
            loginError: that.props.t("Wrong username or password"),
          });
          return;
        }

        if (resp.success === true) {
          if (resp.roles === undefined || resp.roles.length === 0) return;

          if (
            resp.roles.indexOf(roles.ADMIN) === -1 &&
            resp.roles.indexOf(roles.ASSIGNE) === -1 &&
            resp.roles.indexOf(roles.COMMERCIO) === -1 &&
            resp.roles.indexOf(roles.EXTERNAL) === -1
          )
            return;

          that.tmpToken = resp.token;

          let nextPage = () => {
            localStorage.setItem("token", resp.token);

            if (resp.brand) {
              localStorage.setItem("brand", resp.brand);
            } else {
              localStorage.removeItem("brand");
              localStorage.removeItem("brandObj");
            }

            // window.location.refresh();
            // return fetch('/',
            // 	{ method : "GET",
            // 		headers : new Headers (
            // 	 	{ "x-access-token" : resp.token}) }
            // 	);

            localStorage.removeItem("user");
            localStorage.setItem("user", JSON.stringify(resp));

            // Vite dev server: the page lives at /static/login.html, not a
            // real Express route, so the resubmit below has nothing to
            // land on - navigate to the right page directly instead.
            if (import.meta.env.DEV) {
              // ?next= (set by vite.config.mjs's devPageRouter or
              // authNav.js's redirectToLogin) preserves a specific page the
              // user was actually trying to reach - e.g. admin.html, which
              // getLandingPage() has no concept of at all (it only knows
              // the generic role-based default). Only accept a plain
              // filename, never anything with a path in it.
              const nextParam = new URLSearchParams(window.location.search).get("next");
              const next = nextParam && /^[\w.-]+\.html$/.test(nextParam) ? nextParam : null;

              const page = next || getLandingPage(resp.roles);
              if (page) window.location.href = `./${page}`;
              return;
            }

            that.tokenRef.current.value = localStorage.getItem("token");
            that.formRef.current.action = window.location.pathname;
            that.formRef.current.submit();
          };

          if (resp.gdpr == false) {
            that.onAcceptGdpr = nextPage;

            // Rendered via Dialog's TransitionProps.onEnter below, not this
            // setState's own callback - the Dialog portals its content and
            // hasn't attached gdprContentRef.current yet at that point.
            that.setState({
              gdprDialog: true,
            });
          } else {
            nextPage();
          }
        }
      })
      // .then(function(data) {
      // 	if (data.status=== 200) {
      // 		return data.text();
      // 	}
      // }).then(function(text){
      // 	document.write(text);
      // 	document.close();
      // })
      .catch(function () {
        console.log("error");
        that.setState({
          logging: false,
        });
      });
  }

  _validate(target) {
    // console.log("b")
    if (target.value.length === 0) {
      const name = target.name;

      this.setState({
        ["err" + name]: this.errors[name],
      });
      return false;
    } else {
      this.setState({
        ["err" + name]: "",
      });
      return true;
    }
  }

  _move(e) {
    // console.log("a",e)
    if (e.key === "Enter") {
      e.preventDefault();

      const target = e.target;

      if (this._validate(target) === false) return;

      if (target.name == "name") {
        this.inputNode.focus();
      } else {
        this.login(e);
      }
    }
  }

  handleToggle = () => {
    // this.setState({errDlgTasksActive: !this.state.errDlgTasksActive});
  };

  _detectCountry = () => {
    let l = getDetectedCounty();

    switch (l) {
      case "en": {
        return "en";
        break;
      }

      case "de": {
        return "de";
        break;
      }

      case "sl": {
        return "sl";
        break;
      }
    }

    return "en";
  };

  onPermissionClicked = (el) => {
    //console.log("onPermission", el);
    //console.log(el.id, el.checked, el.all);

    if (!this.permissions) {
      this.permissions = {};
    }

    this.permissions[el.id] = el.checked;

    let checked = 0;
    for (let i in this.permissions) {
      const perm = this.permissions[i];
      if (perm) {
        ++checked;
      }
    }

    this.setState({
      gdpr: checked == el.all,
    });
  };

  renderGdpr = () => {
    const { gdprContent } = this.state;
    if (!this.gdprContentRef.current) return;

    window.onPermissionClicked = this.onPermissionClicked;

    const req =
      '<object type="text/html" data="/gdpr?p=1&l=' +
      this._detectCountry() +
      '"  style="width:100%;height:100%;overflow-y:auto"></object>';
    this.gdprContentRef.current.innerHTML = req;
  };

  acceptGdpr = () => {
    const that = this;

    this.setState(
      {
        gdprAccepting: true,
      },
      () => {
        fetch("/acceptGdpr", {
          method: "POST",
          redirect: "follow",
          headers: new Headers({
            "Content-Type": "application/json",
            "x-access-token": this.tmpToken,
          }),
          body: undefined,
        })
          .then(function (data) {
            // console.log("response", data);

            if (data.status === 200) {
              return data.json();
            }
          })
          .then((data) => {
            if (data.err) {
              console.log("data err", data.err);
              return that.setState({
                gdprAccepting: false,
              });
            }

            that.onAcceptGdpr();
          })
          .catch(function (err) {
            console.log("error", err);
            //return Promise.resolve({ err : err});
            that.setState({
              gdprAccepting: false,
            });
          });
      }
    );
  };

  render() {
    const { t } = this.props;
    const { logo } = this.state;

    const wrapstyle = { ...style.wrapper, visibiliy: "visible" };

    let progress = null;
    if (this.state.logging === true) {
      progress = (
        <CircularProgress />
      );
    }

    let logoEl = null;
    if (logo) {
      logoEl = (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
          }}
        >
          <img src={logo} />
        </div>
      );
    }
    return (
      <div style={wrapstyle}>
        <form
          className="form-signin"
          method="post"
          action="/"
          ref={this.formRef}
        >
          {logoEl}
          <h2>{t("Please login")}</h2>

          <Input type="text" label={t("Username")} name="name" value={this.state.name} onKeyPress={(e) => this._move(e)} onBlur={() => this.setState({ errname: "" })} onChange={(e) => (this.handleChange.bind(this, "name"))(e.target.value, e)} error={!!(this.state.errname)} helperText={this.state.errname} />
          <Input type="password" label={t("Password")} name="password" value={this.state.password} onKeyPress={(e) => this._move(e)} onBlur={() => this.setState({ errpassword: "" })} onChange={(e) => (this.handleChange.bind(this, "password"))(e.target.value, e)} error={!!(this.state.errpassword)} helperText={this.state.errpassword} inputRef={(node) => {
              this.inputNode = node;
            }} />

          {this.state.loginError ? (
            <Typography color="error" variant="body2" sx={{ mt: 1 }}>
              {this.state.loginError}
            </Typography>
          ) : null}

          <input type="hidden" name="token" ref={this.tokenRef} />

          <Button
            style={{ width: "100%", marginTop: "30px" }}
            type="submit"
            onClick={(e) => this.login(e)}
          startIcon={<Icon>perm_identity</Icon>}
          variant="contained"
          color="primary"
          >{t("login")}</Button>

          <div style={style.refresh}>{progress}</div>
        </form>

        <Dialog
          maxWidth="md"
          fullWidth
          open={this.state.gdprDialog}
          onClose={this.handleToggle}
          slotProps={{ transition: { onEnter: () => this.renderGdpr() } }}
        >
          <DialogContent>
          <div
            style={{
              height: "75vh",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div style={{ flex: 1 }}>
              <div
                ref={this.gdprContentRef}
                style={{ width: "100%", height: "100%" }}
              >
                <LinearProgress sx={{ width: "100%" }} />
              </div>

              {this.state.gdprAccepting == true ? (
                <LinearProgress sx={{ width: "100%" }} />
              ) : null}
            </div>

            <div
              style={{
                flex: 0,
                display: "flex",
                minHeight: "20px",
                justifyContent: "flex-end",
                borderTop: "1px solid #808080",
                paddingTop: "5px",
              }}
            >
              {/* <div style={{marginTop: "10px", marginRight : "10px"}}>
							<Checkbox
								checked={this.state.gdpr}
								label=""
								onChange={(value) => { this.setState({gdpr : value})}}
							/>
						</div> */}

              <Button
                disabled={
                  this.state.gdpr === false || this.state.gdprAccepting == true
                }
                onClick={this.acceptGdpr}
              startIcon={<Icon>done_outline</Icon>}
              variant="contained"
              color="secondary"
              >{t("ACCEPT")}</Button>
            </div>
          </div>
          </DialogContent>
        </Dialog>
      </div>
    );
  }
}

const style = {
  wrapper: {
    position: "relative",
    maxWidth: "356px",
    padding: "70px",
    margin: "auto",
    width: "50%",
    marginTop: "100px",
    backgroundColor: "white",
    visibiliy: "hidden",
  },
  refresh: {
    position: "absolute",
    right: "46%",
    bottom: "15px",
    // position: 'absolute',
    // bottom: '10px'
  },
};

// render((
//   <MuiThemeProvider >
//   	<LoginForm />
//   </MuiThemeProvider>
// ), document.getElementById('app'));

const LoginForm = translate(["translation"], { wait: true })(LoginFormEn);

createRoot(document.getElementById("app")).render(
  <ThemeProvider theme={muiTheme}>
    <I18nextProvider i18n={i18next}>
      <LoginForm />
    </I18nextProvider>
  </ThemeProvider>,
);
